/* @flow */
const conditionFullTypes = {
  percentageDecrease: 'Percentage Decrease',
  percentageIncrease: 'Percentage Increase',
  flatDecrease: 'Flat Decrease',
  flatIncrease: 'Flat Increase',
};

export const percentageDecreaseName = 'percentage_decrease';
export const percentageIncreaseName = 'percentage_increase';
export const lowerText = 'lower';
export const higherText = 'higher';
export const percentage = 'Percentage';
export const flat = 'Flat';
export const upDirection = 'increase';
export const downDirection = 'decrease';

const conditionPercentDecreaseOption = {
  value: conditionFullTypes.percentageDecrease,
  name: percentageDecreaseName,
  type: percentage,
  direction: downDirection,
};
const conditionPercentIncreaseOption = {
  value: conditionFullTypes.percentageIncrease,
  name: percentageIncreaseName,
  type: percentage,
  direction: upDirection,
};

export const conditionOptions: Array<iConditionOption> = [
  conditionPercentDecreaseOption,
  conditionPercentIncreaseOption,
  {
    value: conditionFullTypes.flatDecrease,
    name: 'flat_decrease',
    type: flat,
    direction: downDirection,
  },
  {
    value: conditionFullTypes.flatIncrease,
    name: 'flat_increase',
    type: flat,
    direction: upDirection,
  },
];

export const conditionTypes: Array<string> = [flat, percentage];
export const conditionDirections: Array<string> = [upDirection, downDirection];

export const setAlertOptions: Array<iOption> = [
  {
    ...conditionPercentIncreaseOption,
    text: higherText,
  },
  {
    ...conditionPercentDecreaseOption,
    text: lowerText,
  },
];



// WEBPACK FOOTER //
// ./src/models/AlertsConditionTypes.js